import { Navigate, Outlet } from "react-router-dom";

export const ProtectedRoute = () => {
  const token = localStorage.getItem("token");
  const lastStep = localStorage.getItem("last_complete_step");
  const isVerified = localStorage.getItem("is_verified");

  // ❌ Not logged in
  if (!token) {
    return <Navigate to="/otpLogin" replace />;
  }

  // ❌ OTP not verified
  if (isVerified !== "1") {
    clearAuth();
    return <Navigate to="/otpLogin" replace />;
  }

  // 🚨 Registration incomplete
  // if (!lastStep || lastStep === "step_1_flag") {
  //   return <Navigate to="/register/professional" replace />;
  // }

  // if (lastStep === "step_2_flag") {
  //   return <Navigate to="/register/contact" replace />;
  // }

  if (lastStep !== "MOBILE_CHECK" && lastStep !== "MOBILE_CHECK") {
    return <Navigate to="/my_matches" replace />;
  }

  // ✅ Registration done → allow navigation
  return <Outlet />;
};

const clearAuth = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("user");
  localStorage.removeItem("is_verified");
};
